import { useState } from "react";
import styled from "styled-components";
import { colors, measurments } from "../utils/config";
import SVG from "./SVG";

const StyledTextarea = styled.div`
  display: flex;
  flex-direction: column;
  label {
    display: block;
    margin-bottom: 0.25rem;
    color: ${colors.neutral[90]};
  }
  textarea {
    padding: 0.375rem 0.75rem;
    border-radius: ${measurments.borderRadius}px;
    border: 1px solid ${colors.neutral[50]};
    background: ${colors.neutral[10]};
    width: 100%;
    resize: none;
    min-height: 6rem;
    height: ${({ h }) => h}rem;
  }
  margin-bottom: 0.95rem;
  .input-component-container {
    position: relative;
    .input-eye-toggle {
      position: absolute;
      top: 0;
      right: 0.75rem;
      bottom: 0;
      height: 100%;
      align-items: center;
      display: flex;
    }
  }
`;

const Textarea = (props) => {
  const [passwordVisible, setPasswordVisible] = useState(false);
  return (
    <StyledTextarea
      h={props.h}
      className={`${props.className} ${
        passwordVisible ? "password-visible" : ""
      }`}
    >
      {!!props.label && (
        <label htmlFor={props.id || props.name} className="b2">
          {props.label}
        </label>
      )}
      <div className="input-component-container">
        <textarea
          {...props}
          id={props.id || props.name}
          className="b2"
          type={
            props.type === "password"
              ? passwordVisible
                ? "text"
                : "password"
              : props.type
          }
        />
        {props.type === "password" && (
          <div
            className="input-eye-toggle"
            role="button"
            onClick={() => setPasswordVisible(!passwordVisible)}
          >
            {passwordVisible ? (
              <SVG name="eye-closed" stroke={colors.neutral[90]} />
            ) : (
              <SVG name="eye" stroke={colors.neutral[90]} />
            )}
          </div>
        )}
      </div>
    </StyledTextarea>
  );
};

export default Textarea;
